import axios from '../../../../../utils/axios';

interface LoginPicture {
    id: string;
    configType: string;
    pictureUrl: string;
}

interface LoginPictureConfig {
    logo: LoginPicture[];
    background: LoginPicture[];
}

export async function getLoginConfig() {
    const data = await axios.request<LoginPictureConfig>({
        url: '/api/ops/config/picture/loginPage'
    });
    const logo = data.logo?.[0];
    const background = data.background?.[0];
    return {
        logoId: logo?.id,
        logo: logo?.pictureUrl,
        backgroundId: background?.id,
        background: background?.pictureUrl
    };
}

export async function removeLoginBackground(id: string) {
    await axios.request({
        method: 'delete',
        url: `/api/ops/config/picture/delete/${id}`
    });
}
